import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  Radio,
  useTheme,
} from "@material-ui/core";
import React from "react";
import { useSelector } from "react-redux";
import { CollectionService } from "../services";
import {
  selectCollections,
  selectSelectedCollection,
} from "../store/collection/collection.selector";
import style from "./style";

interface IProps {
  open: boolean;
  onClose: () => void;
}

const CollectionSelectModal: React.FC<IProps> = ({ open, onClose }) => {
  const theme = useTheme();
  const collections = useSelector(selectCollections);
  const selectedCollection = useSelector(selectSelectedCollection);
  const classes = style();

  const handleCollectionSelector = (collectionName: string) => {
    CollectionService.selectCollection(collectionName);
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      classes={{
        paper: classes.dialogPaper,
      }}
    >
      <DialogTitle
        style={{
          backgroundColor: theme.palette.primary.main,
          color: theme.palette.text.secondary,
        }}
      >
        Collections
      </DialogTitle>
      <DialogContent classes={{ root: classes.dialogContentRoot }}>
        <List>
          {collections.data &&
            collections.data.map((collectionName) => (
              <ListItem
                button
                key={collectionName}
                onClick={() => handleCollectionSelector(collectionName)}
              >
                <ListItemSecondaryAction>
                  <Radio
                    checked={selectedCollection.data?.name === collectionName}
                    color="primary"
                  />
                </ListItemSecondaryAction>
                <ListItemText>{collectionName}</ListItemText>
              </ListItem>
            ))}
        </List>
      </DialogContent>
      <Divider />
      <DialogActions>
        <Button
          style={{
            textTransform: "none",
            borderColor: theme.palette.error.light,
            color: theme.palette.error.light,
          }}
          variant="outlined"
          disableRipple
          onClick={onClose}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CollectionSelectModal;
